var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container mx-auto px-5"},[_c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("../assets/logo_tac.png")}})])])])
}]

export { render, staticRenderFns }